// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__N1f6i","approved":"Status_approved__1WiuA","rejected":"Status_rejected__1VjCy","expired":"Status_expired__Kt1-b","label":"Status_label__3QMNQ"};